import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import SelectedLocationContainer from 'bento-ordering/locations/containers/SelectedLocationContainer';

/**
 * This is a wrapper component that sets some custom copy
 * for the order setting screen. Behind the scene
 * location details and order settings use the
 * SelectedLocationContainer component
 */
class OrderSettingContainer extends React.Component {
  static propTypes = {
    selectedLocationId: PropTypes.number,
    closeModal: PropTypes.func,
    isAsapAvailableForDelivery: PropTypes.bool,
    isAsapAvailableForPickup: PropTypes.bool
  };

  render() {
    const {
      closeModal,
      selectedLocationId,
      isAsapAvailableForDelivery,
      isAsapAvailableForPickup
    } = this.props;
    return (
      <SelectedLocationContainer
        id={selectedLocationId}
        buttonLabel="Update Time"
        closeModal={closeModal}
        isAsapAvailableForDelivery={isAsapAvailableForDelivery}
        isAsapAvailableForPickup={isAsapAvailableForPickup}
      />
    );
  }
}

const mapStateToProps = state => {
  const { cart } = state;
  const selectedLocationId = cart.online_ordering_location;
  return {
    selectedLocationId
  };
};

export default withRouter(connect(mapStateToProps)(OrderSettingContainer));
